// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_v {
    margin: 20px auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    max-width: 600px;
  }
  
  .vconnect_head {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
  .btns{
    display: flex;
    justify-content: center;
  }
.vconnect_container{
    width: 100%;
    height:97vh;
}

  .select-container {
    display: flex;
    gap: 10px;
    justify-content: center;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  
  .table th,
  .table td {
    border: 1px solid #ccc;
    padding: 8px;
  }
  
  
  
  .table td select,
  .table td input[type="text"] {
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
  }
  
  .btn_v {
    padding: 8px 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
  }
  
  .btn:hover {
    background-color: #0056b3;
  }
  
  .value-mapping-container {
    margin-top: 10px;
  }
  
  .value-mapping-container input[type="text"] {
    margin-top: 5px;
  }

  .submit-btn{
    margin-left: 10px;
  }

  /* Modal styles */

  
  .modal input[type="text"] {
    margin-bottom: 10px;
    width: calc(100% - 20px);
    padding: 8px;
    border: 2px solid #ccc;
    border-radius: 2px;
    background-color: white;
    color: black;
    margin: 2px;
  }
  .label {
    margin-bottom: 5px; /* Adjust as needed */
    font-weight: bold;
    padding: 2px;
  }
  

  .modal_v .btn_v {
    margin-right: 10px;
    padding: 6px 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 0px;
  }
  
  .modal_v .btn_v:hover {
    background-color: #0056b3;
  }
  
  .modal_v .remove-btn {
    background-color: #dc3545;
  }
  
  .modal_v .remove-btn:hover {
    background-color: #c82333;
  }

  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: transparent;
    color: #333;
    border: none;
    cursor: pointer;
    font-size: 16px;
  }
  
  .close-btn:hover {
    color: #999;
  }

  .remove-btn {
    margin-left: 5px;
    background-color: #dc3545;
  }
  
  .remove-btn:hover {
    background-color: #c82333;
  }

  .modal_v {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    width: 400px;
    min-height: 200px;
  }
  
  .modal_v input {
    margin-bottom: 10px;
    width: calc(50% - 10px);
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .value-mapping-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  
  .value-mapping-container button {
    border: none;
    background-color: transparent;
    cursor: pointer;
    color: #007bff;
    font-size: 14px;
  }`, "",{"version":3,"sources":["webpack://./src/components/Vconnect.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;AACF;IACI,WAAW;IACX,WAAW;AACf;;EAEE;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;EACd;;;;EAIA;;IAEE,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,iBAAiB;;;EAGjB;IACE,mBAAmB;IACnB,wBAAwB;IACxB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;EACA;IACE,kBAAkB,EAAE,qBAAqB;IACzC,iBAAiB;IACjB,YAAY;EACd;;;EAGA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,cAAc;IACd,eAAe;EACjB","sourcesContent":[".container_v {\r\n    margin: 20px auto;\r\n    padding: 20px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    max-width: 600px;\r\n  }\r\n  \r\n  .vconnect_head {\r\n    font-size: 1.5rem;\r\n    margin-bottom: 20px;\r\n  }\r\n  .btns{\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n.vconnect_container{\r\n    width: 100%;\r\n    height:97vh;\r\n}\r\n\r\n  .select-container {\r\n    display: flex;\r\n    gap: 10px;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  .table th,\r\n  .table td {\r\n    border: 1px solid #ccc;\r\n    padding: 8px;\r\n  }\r\n  \r\n  \r\n  \r\n  .table td select,\r\n  .table td input[type=\"text\"] {\r\n    width: 100%;\r\n    padding: 5px;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .btn_v {\r\n    padding: 8px 16px;\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .btn:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  .value-mapping-container {\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .value-mapping-container input[type=\"text\"] {\r\n    margin-top: 5px;\r\n  }\r\n\r\n  .submit-btn{\r\n    margin-left: 10px;\r\n  }\r\n\r\n  /* Modal styles */\r\n\r\n  \r\n  .modal input[type=\"text\"] {\r\n    margin-bottom: 10px;\r\n    width: calc(100% - 20px);\r\n    padding: 8px;\r\n    border: 2px solid #ccc;\r\n    border-radius: 2px;\r\n    background-color: white;\r\n    color: black;\r\n    margin: 2px;\r\n  }\r\n  .label {\r\n    margin-bottom: 5px; /* Adjust as needed */\r\n    font-weight: bold;\r\n    padding: 2px;\r\n  }\r\n  \r\n\r\n  .modal_v .btn_v {\r\n    margin-right: 10px;\r\n    padding: 6px 16px;\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-top: 0px;\r\n  }\r\n  \r\n  .modal_v .btn_v:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  .modal_v .remove-btn {\r\n    background-color: #dc3545;\r\n  }\r\n  \r\n  .modal_v .remove-btn:hover {\r\n    background-color: #c82333;\r\n  }\r\n\r\n  .close-btn {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background-color: transparent;\r\n    color: #333;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .close-btn:hover {\r\n    color: #999;\r\n  }\r\n\r\n  .remove-btn {\r\n    margin-left: 5px;\r\n    background-color: #dc3545;\r\n  }\r\n  \r\n  .remove-btn:hover {\r\n    background-color: #c82333;\r\n  }\r\n\r\n  .modal_v {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background-color: white;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    width: 400px;\r\n    min-height: 200px;\r\n  }\r\n  \r\n  .modal_v input {\r\n    margin-bottom: 10px;\r\n    width: calc(50% - 10px);\r\n    padding: 8px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .value-mapping-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .value-mapping-container button {\r\n    border: none;\r\n    background-color: transparent;\r\n    cursor: pointer;\r\n    color: #007bff;\r\n    font-size: 14px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
